import React from 'react'
import { List, Button, Tooltip, Switch } from 'antd'
import { useIntl } from 'react-intl'
import { EditOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons'
import { FlattenedRateData } from './types'

interface RateMobileListProps {
  rates: FlattenedRateData[]
  loading: boolean
  updatingRateCode: string | null
  isSortMode: boolean
  onEdit: (rateCode: string) => void
  onToggleEnabled: (record: FlattenedRateData, checked: boolean) => void
  onMoveUp: (rateCode: string) => void
  onMoveDown: (rateCode: string) => void
}

const RateMobileList: React.FC<RateMobileListProps> = ({
  rates,
  loading,
  updatingRateCode,
  isSortMode,
  onEdit,
  onToggleEnabled,
  onMoveUp,
  onMoveDown,
}) => {
  const intl = useIntl()

  return (
    <List
      itemLayout="vertical"
      dataSource={rates}
      loading={loading}
      renderItem={(item, index) => (
        <List.Item
          key={item.rate_code}
          actions={
            isSortMode
              ? [
                  <Button
                    type="text"
                    icon={<ArrowUpOutlined />}
                    disabled={index === 0}
                    onClick={() => onMoveUp(item.rate_code)}
                  />,
                  <Button
                    type="text"
                    icon={<ArrowDownOutlined />}
                    disabled={index === rates.length - 1}
                    onClick={() => onMoveDown(item.rate_code)}
                  />,
                ]
              : [
                  <Tooltip title={intl.formatMessage({ id: 'common.edit', defaultMessage: 'Edit' })}>
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() => onEdit(item.rate_code)}
                    />
                  </Tooltip>,
                  <Switch
                    checked={item.enabled}
                    onChange={(checked) => onToggleEnabled(item, checked)}
                    loading={updatingRateCode === item.rate_code}
                    size="small"
                  />,
                ]
          }
        >
          <List.Item.Meta
            title={item.rate_code}
            description={item.display_name}
          />
        </List.Item>
      )}
    />
  )
}

export default RateMobileList
